import React, { memo, useEffect, useRef, useState, forwardRef, useCallback, useImperativeHandle } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import ResizeObserver from 'react-resize-observer';

import { FixedSizeList } from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";
import { Scrollbars } from "react-custom-scrollbars";

import { HighlightSpan } from './PriceBoardTotalMode';
//
import { changeSortConfig, addFavSymbol, removeFavSymbol, changeSelectShowInfo, showPopupInfo, removeFindSymbol, changeSortConfigMenu } from '../redux/actions/sharedActions';

import { formatQtty, formatNumberToM, formatNumber } from '../helpers/utils';

// ===== TABLE DETAIL =====
export default memo(function PriceBoardOddDetailMode(props) {
    // Props var
    const { symbolInfos } = props;

    //
    return (
        <div className={'price-board'}>
            <TableBody symbolInfos={symbolInfos} />
        </div>
    )
})

//
const TableBody = forwardRef((props, ref) => {
    //
    const { symbolInfos, onScroll } = props;
    //
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const findSymbol = useSelector(state => state.gShared.findSymbol);
    const priceBoardSortConfig = useSelector(state => state.gShared.priceBoardSortConfig);
    const crrSortColumn = priceBoardSortConfig ? priceBoardSortConfig.column ?? '' : '';
    const crrSortType = priceBoardSortConfig ? priceBoardSortConfig.type ?? '' : '';

    const priceBoardColumnConfig_UpdateTime = useSelector(state => state.gShared.priceBoardColumnConfig?.updateTime);
    const priceBoardColumnConfig = useSelector(state => state.gShared.priceBoardColumnConfig?.DETAIL ?? {});

    const configSortColumnMenu = useSelector((state) => state.gShared.configSortColumnMenu);
    //
    const refHeaderRow = useRef(null);
    const [headerRowHeight, setHeaderRowHeight] = useState(0);

    const refBidPrice3 = useRef(null);
    const refBidQtty1 = useRef(null);

    const refOfferPrice1 = useRef(null);
    const refOfferQtty3 = useRef(null);

    const [showTotalValue, setShowTotalValue] = useState(false);

    //
    const refBid = useRef(null);
    const refOffer = useRef(null);
    const refTable = useRef(null);
    const refScroll = useRef(null);

    useImperativeHandle(ref, () => ({
        scrollBody: refScroll.current,
        scrollToItem: (itemIdx) => {
            if (refTable.current) {
                refTable.current.scrollToItem(itemIdx);
            }
        },
    }));

    const configColumnNameTable = {
        symbolColAsc: 'code',
        symbolColDesc: 'code',
        totalQttyColAsc: 'totalTradedQttyOdd',
        totalQttyColDesc: 'totalTradedQttyOdd',
        foreignBuyColAsc: '',
        foreignBuyColDesc: '',
        foreignSellColAsc: '',
        foreignSellColDesc: '',
    };

    useEffect(() => {
        changeSortConfigMenu(dispatch, configColumnNameTable, configSortColumnMenu);
    }, [configSortColumnMenu])


    //
    const measureRefBid = useCallback(node => {
        if (node !== null) {
            refBid.current = node;
        }
    }, [])

    //
    const measureRefOffer = useCallback(node => {
        if (node !== null) {
            refOffer.current = node;
        }
    }, [])

    const _handleChangeShowTotalValue = () => {
        if (showTotalValue) {
            setShowTotalValue(false);
        }
        else {
            setShowTotalValue(true);
        }
    }

    const _handleClickSort = (colName, dataType) => {
        changeSortConfig(dispatch, crrSortColumn, crrSortType, colName, dataType);
    }

    const _handleScroll = useCallback(({ target }) => {
        const { scrollTop, scrollLeft } = target;
        if (refTable.current) {
            refTable.current.scrollTo(scrollTop);
        }
        //
        if (onScroll) {
            try {
                onScroll({ target });
            } catch (error) {
            }
        }
    }, [refTable.current])

    const _handleTableScroll = useCallback(({ scrollDirection, scrollOffset, scrollUpdateWasRequested }) => {
        if (refScroll.current) {
            refScroll.current.scrollTop(scrollOffset);
        }
        if (findSymbol && findSymbol.code && findSymbol.code !== "") {
            removeFindSymbol(dispatch, "");
        }
    }, [refScroll.current])

    const _scrollToSymbol = () => {
        if (refTable.current) {
            if (findSymbol && findSymbol.code && findSymbol.code !== "" && symbolInfos && symbolInfos.length > 0) {
                const _idx = symbolInfos.findIndex(e => e.code === findSymbol.code);
                if (_idx >= 0) {
                    if (refTable.current) {
                        refTable.current.scrollToItem(_idx, 'start');
                    }
                }
            }
        }
        else {
            setTimeout(() => {
                _scrollToSymbol();
            }, 100);
        }
    }

    const _calcDivBidPosition = () => {
        if (refHeaderRow.current && refBidPrice3.current && refBidQtty1.current && refBid.current) {
            const _headerRowRect = refHeaderRow.current.getBoundingClientRect();
            const _bidPrice3Rect = refBidPrice3.current.getBoundingClientRect();
            const _bidQtty1Rect = refBidQtty1.current.getBoundingClientRect();
            const _left = _bidPrice3Rect.x - _headerRowRect.x;
            const _width = (_bidQtty1Rect.x - _bidPrice3Rect.x) + _bidQtty1Rect.width;
            refBid.current.style.left = _left + "px";
            refBid.current.style.width = _width + "px";
        }
        else {
            setTimeout(() => { _calcDivBidPosition(); }, 250);
        }
    }

    const _calcDivOfferPosition = () => {
        if (refHeaderRow.current && refOfferPrice1.current && refOfferQtty3.current && refOffer.current) {
            const _headerRowRect = refHeaderRow.current.getBoundingClientRect();
            const _offerPrice1Rect = refOfferPrice1.current.getBoundingClientRect();
            const _offerQtty3Rect = refOfferQtty3.current.getBoundingClientRect();
            const _left = _offerPrice1Rect.x - _headerRowRect.x;
            const _width = (_offerQtty3Rect.x - _offerPrice1Rect.x) + _offerQtty3Rect.width;
            refOffer.current.style.left = _left + "px";
            refOffer.current.style.width = _width + "px";
        }
        else {
            setTimeout(() => { _calcDivOfferPosition(); }, 250);
        }
    }

    const _calcDivPosition = () => {
        _calcDivBidPosition();
        _calcDivOfferPosition();
    }

    //
    useEffect(() => {
        _scrollToSymbol();
    }, [findSymbol.counter, symbolInfos.length])

    useEffect(() => {
        _calcDivPosition();
    }, [priceBoardColumnConfig_UpdateTime])

    //
    return (
        <AutoSizer>
            {({ height, width }) => {
                return (
                    <Scrollbars
                        ref={refScroll}
                        autoHide={true}
                        autoHeight={true}
                        autoHeightMax={height}
                        onScroll={_handleScroll}
                        style={{ width: width, position: 'relative' }}
                        renderTrackHorizontal={props => <div {...props} className="scroll-track-horizontal" />}
                        renderTrackVertical={props => <div {...props} className="scroll-track-vertical" />}
                        renderThumbHorizontal={props => <div {...props} className="scroll-thumb-horizontal" />}
                        renderThumbVertical={props => <div {...props} className="scroll-thumb-vertical" />}
                        renderView={props => <div {...props} className="scroll-view" />}
                        className={"scroll-container"}
                    >
                        <div style={{ width: '100%', position: 'sticky', top: 0, zIndex: 1 }}>
                            <div ref={refHeaderRow} className="prc-row-head prc-row-head-spec">
                                <ResizeObserver onResize={(rect) => { _calcDivPosition(); }} onPosition={(rect) => { _calcDivPosition(); }} onReflow={(rect) => { _calcDivPosition(); }} />

                                {/* <div className="prc-col mw-40"></div> */}
                                {priceBoardColumnConfig.showCode && (
                                    <div className={clsx("prc-col4 text-center mw-75 mxw-75 th-sort bdl-white", (crrSortColumn === 'code' ? 'th-sort-' + crrSortType : ''))} onClick={() => _handleClickSort('code')}>{t('maCK')}</div>
                                )}
                                <div className={clsx("prc-col2 text-center th-sort", (crrSortColumn === 'ceilPrice' ? 'th-sort-' + crrSortType : ''))} onClick={() => _handleClickSort('ceilPrice', 'number')}>{t('tran')}</div>
                                <div className={clsx("prc-col2 text-center th-sort", (crrSortColumn === 'floorPrice' ? 'th-sort-' + crrSortType : ''))} onClick={() => _handleClickSort('floorPrice', 'number')}>{t('san')}</div>
                                <div className={clsx("prc-col2 text-center th-sort", (crrSortColumn === 'refPrice' ? 'th-sort-' + crrSortType : ''))} onClick={() => _handleClickSort('refPrice', 'number')}>{t('tc')}</div>

                                <div ref={refBidPrice3} className={clsx("prc-col-rs prc-col2 text-center th-sort bdl-white", (crrSortColumn === 'bidPriceOdd3' ? 'th-sort-' + crrSortType : ''))} onClick={() => _handleClickSort('bidPriceOdd3', 'number')}>
                                    {t('gia3')}
                                    <ResizeObserver onResize={(rect) => { _calcDivPosition(); }} onPosition={(rect) => { _calcDivPosition(); }} onReflow={(rect) => { _calcDivPosition(); }} />
                                </div>
                                <div className={clsx("prc-col-rs prc-col2 mw-65 text-center th-sort", (crrSortColumn === 'bidQttyOdd3' ? 'th-sort-' + crrSortType : ''))} onClick={() => _handleClickSort('bidQttyOdd3', 'number')}>{t('kl3')}</div>
                                <div className={clsx("prc-col-rs prc-col2 text-center th-sort", (crrSortColumn === 'bidPriceOdd2' ? 'th-sort-' + crrSortType : ''))} onClick={() => _handleClickSort('bidPriceOdd2', 'number')}>{t('gia2')}</div>
                                <div className={clsx("prc-col-rs prc-col2 mw-65 text-center th-sort", (crrSortColumn === 'bidQttyOdd2' ? 'th-sort-' + crrSortType : ''))} onClick={() => _handleClickSort('bidQttyOdd2', 'number')}>{t('kl2')}</div>
                                <div className={clsx("prc-col-rs prc-col2 text-center th-sort", (crrSortColumn === 'bidPriceOdd1' ? 'th-sort-' + crrSortType : ''))} onClick={() => _handleClickSort('bidPriceOdd1', 'number')}>{t('gia1')}</div>
                                <div ref={refBidQtty1} className={clsx("prc-col-rs prc-col2 mw-65 text-center th-sort", (crrSortColumn === 'bidQttyOdd1' ? 'th-sort-' + crrSortType : ''))} onClick={() => _handleClickSort('bidQttyOdd1', 'number')}>
                                    {t('kl1')}
                                    <ResizeObserver onResize={(rect) => { _calcDivPosition(); }} onPosition={(rect) => { _calcDivPosition(); }} onReflow={(rect) => { _calcDivPosition(); }} />
                                </div>
                                <div ref={measureRefBid} className={"prc-col-cs prc-col-bid bdl-white"}>{t('muaBid')}</div>

                                <div className="prc-col4 text-center mw-75 mxw-75 bdl-white"></div>

                                {priceBoardColumnConfig.showCodeMatch && (
                                    <div className={clsx("prc-col4 text-center mw-75 mxw-75 th-sort", (crrSortColumn === 'code' ? 'th-sort-' + crrSortType : ''))} onClick={() => _handleClickSort('code')}>{t('maCK')}</div>
                                )}
                                <div className={clsx("prc-col2 text-center th-sort", (crrSortColumn === 'matchPriceOdd' ? 'th-sort-' + crrSortType : ''))} onClick={() => _handleClickSort('matchPriceOdd', 'number')}>{t('giaKhop')}</div>
                                <div className={clsx("prc-col2 text-center th-sort", (crrSortColumn === 'changePriceOdd' ? 'th-sort-' + crrSortType : ''))} onClick={() => _handleClickSort('changePriceOdd', 'number')}>+/-</div>
                                <div className={clsx("prc-col2 text-center mw-55 th-sort", (crrSortColumn === 'pctChangePriceOdd' ? 'th-sort-' + crrSortType : ''))} onClick={() => _handleClickSort('pctChangePriceOdd', 'number')}>%</div>
                                <div className={clsx("prc-col2 text-center mw-65 th-sort", (crrSortColumn === 'matchQttyOdd' ? 'th-sort-' + crrSortType : ''))} onClick={() => _handleClickSort('matchQttyOdd', 'number')}>{t('klKhop')}</div>
                                {priceBoardColumnConfig.showTotalTradedQtty && (
                                    <div className='prc-col4 mw-85 d-flex' style={{ paddingTop: 0, paddingBottom: 0 }}>
                                        <div className='d-flex align-items-center h-100 pdr-3 pr-icon-btn' onClick={_handleChangeShowTotalValue}>
                                            <i className="fas fa-caret-left"></i>
                                        </div>
                                        {showTotalValue ? (
                                            <div className={clsx("flex-1 d-flex align-items-center justify-content-center text-center h-100 th-sort", (crrSortColumn === 'totalTradedValueOdd' ? 'th-sort-' + crrSortType : ''))} onClick={() => _handleClickSort('totalTradedValueOdd', 'number')}>{t('tongGTKhop')}</div>
                                        ) : (
                                            <div className={clsx("flex-1 d-flex align-items-center justify-content-center text-center h-100 th-sort", (crrSortColumn === 'totalTradedQttyOdd' ? 'th-sort-' + crrSortType : ''))} onClick={() => _handleClickSort('totalTradedQttyOdd', 'number')}>{t('tongKLKhop')}</div>
                                        )}
                                        <div className='d-flex align-items-center h-100 pdl-3 pr-icon-btn' onClick={_handleChangeShowTotalValue}>
                                            <i className="fas fa-caret-right"></i>
                                        </div>
                                    </div>
                                )}
                                <div ref={refOfferPrice1} className={clsx("prc-col-rs prc-col2 text-center th-sort bdl-white", (crrSortColumn === 'offerPriceOdd1' ? 'th-sort-' + crrSortType : ''))} onClick={() => _handleClickSort('offerPriceOdd1', 'number')}>
                                    {t('gia1')}
                                    <ResizeObserver onResize={(rect) => { _calcDivPosition(); }} onPosition={(rect) => { _calcDivPosition(); }} onReflow={(rect) => { _calcDivPosition(); }} />
                                </div>
                                <div className={clsx("prc-col-rs prc-col2 mw-65 text-center th-sort", (crrSortColumn === 'offerQttyOdd1' ? 'th-sort-' + crrSortType : ''))} onClick={() => _handleClickSort('offerQttyOdd1', 'number')}>{t('kl1')}</div>
                                <div className={clsx("prc-col-rs prc-col2 text-center th-sort", (crrSortColumn === 'offerPriceOdd2' ? 'th-sort-' + crrSortType : ''))} onClick={() => _handleClickSort('offerPriceOdd2', 'number')}>{t('gia2')}</div>
                                <div className={clsx("prc-col-rs prc-col2 mw-65 text-center th-sort", (crrSortColumn === 'offerQttyOdd2' ? 'th-sort-' + crrSortType : ''))} onClick={() => _handleClickSort('offerQttyOdd2', 'number')}>{t('kl2')}</div>
                                <div className={clsx("prc-col-rs prc-col2 text-center th-sort", (crrSortColumn === 'offerPriceOdd3' ? 'th-sort-' + crrSortType : ''))} onClick={() => _handleClickSort('offerPriceOdd3', 'number')}>{t('gia3')}</div>
                                <div ref={refOfferQtty3} className={clsx("prc-col-rs prc-col2 mw-65 text-center th-sort", (crrSortColumn === 'offerQttyOdd3' ? 'th-sort-' + crrSortType : ''))} onClick={() => _handleClickSort('offerQttyOdd3', 'number')}>
                                    {t('kl3')}
                                    <ResizeObserver onResize={(rect) => { _calcDivPosition(); }} onPosition={(rect) => { _calcDivPosition(); }} onReflow={(rect) => { _calcDivPosition(); }} />
                                </div>
                                <div ref={measureRefOffer} className={"prc-col-cs prc-col-ask bdl-white"}>{t('banAsk')}</div>

                                <div className={clsx("prc-col2 text-center bdl-white")}>{t('caoNhat')}</div>
                                <div className={clsx("prc-col2 text-center")}>{t('giaTB')}</div>
                                <div className={clsx("prc-col2 text-center")}>{t('thapNhat')}</div>

                                {priceBoardColumnConfig.showBuyForeignQtty && (
                                    <div className={clsx("prc-col2 text-center mw-70")}>{t('nnMua')}</div>
                                )}
                                {priceBoardColumnConfig.showSellForeignQtty && (
                                    <div className={clsx("prc-col2 text-center mw-70")}>{t('nnBan')}</div>
                                )}
                                {priceBoardColumnConfig.showRemainForeignQtty && (
                                    <div className={clsx("prc-col4 text-center mw-90")}>Room</div>
                                )}
                            </div>
                            <ResizeObserver onResize={(rect) => { setHeaderRowHeight(rect.height); }} />
                        </div>
                        <ScrollContent symbolInfos={symbolInfos} height={height - headerRowHeight} onScroll={_handleTableScroll} showTotalValue={showTotalValue} ref={refTable} />
                    </Scrollbars>
                )
            }}
        </AutoSizer>
    )
})

//
const ScrollContent = memo(forwardRef(function (props, ref) {
    const { symbolInfos, height, onScroll, showTotalValue } = props;
    //
    return (
        <FixedSizeList
            ref={ref}
            height={height}
            width={'100%'}
            itemCount={symbolInfos.length}
            itemSize={28}
            style={{ overflow: false }}
            onScroll={onScroll}
            overscanCount={30}
        >
            {({ index, style }) => {
                const _symbolInfo = symbolInfos[index];
                return (
                    <RowFlex className={"prc-row " + (index % 2 === 0 ? "odd" : "even")} style={{ ...style }}
                        counter={_symbolInfo.counter} code={_symbolInfo.code} showTotalValue={showTotalValue} />
                )
            }}
        </FixedSizeList>
    )
}))

//
const RowFlex = memo(function (props) {
    const { code, showTotalValue } = props;
    //
    const dispatch = useDispatch();
    const prevSymbolCode = useRef(""); // .current

    const tabIsFocus = useSelector(state => state.gShared.tabIsFocus);
    const counter = useSelector(state => state.gSymbol.symbolInfos.find((e) => e.code === code).counter);
    const symbolInfo = useSelector(state => state.gSymbol.symbolInfos.find((e) => e.code === code));
    const isFav = useSelector(state => state.gShared.priceBoardFavSymbols.indexOf(symbolInfo.code) >= 0);

    const priceBoardColumnConfig_UpdateTime = useSelector(state => state.gShared.priceBoardColumnConfig?.updateTime);
    const priceBoardColumnConfig = useSelector(state => state.gShared.priceBoardColumnConfig?.DETAIL ?? {});

    const _fireEvent = prevSymbolCode.current === symbolInfo.code && tabIsFocus;

    const priceBoardFavSymbols = useSelector((state) => state.gShared.priceBoardFavSymbols);
    const lastSymbol = useSelector((state) => state.gShared.lastSymbol);

    //
    const _addFavSymbol = useCallback((code) => {
        addFavSymbol(dispatch, code);
    }, [])

    const _removeFavSymbol = useCallback((code) => {
        removeFavSymbol(dispatch, code);
    }, [])

    const _handleRowClick = useCallback((event, code) => {
        if (code) {
            if (code + "_code" === event.target.id || code + "_codeMatch" === event.target.id) {
                showPopupInfo(dispatch, "ST", code);
            }
            else if (code + "_star" === event.target.id) {
                //
            }
            else {
                changeSelectShowInfo(dispatch, "ST", code);
            }
        }
    }, [])
    //
    useEffect(() => {
        prevSymbolCode.current = symbolInfo.code;
    }, [symbolInfo.code]);

    const changeFavSymbol = (checked, code) => {
        if (checked) {
            _addFavSymbol(code);
        } else {
            _removeFavSymbol(code)
        }
    }

    return (
        <div onClick={(event) => _handleRowClick(event, symbolInfo.code)} className={`${props.className} ${lastSymbol === symbolInfo.code ? "lastSymbol" : ""}`} style={{ ...props.style }}>
            {/* <div className="prc-col text-center mw-40">
                {
                    isFav ? (
                        <span onClick={() => _removeFavSymbol(symbolInfo.code)} style={{cursor: 'pointer', lineHeight: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%'}}><img id={symbolInfo.code + "_star"} className="imgstar" src="/static/img/icon/icon-star-yellow.svg" alt="img" />&nbsp;</span>
                    ) : (
                        <span onClick={() => _addFavSymbol(symbolInfo.code)} style={{cursor: 'pointer', lineHeight: 0,display:'flex',alignItems: 'center',justifyContent:'center',height: '100%' }}><img id={symbolInfo.code + "_star"} className="imgstar" src="/static/img/icon/icon-star.svg" alt="img" />&nbsp;</span>
                    )
                }
            </div> */}
            {priceBoardColumnConfig.showCode && (
                <div className="prc-col4 text-center mw-75 mxw-75 has-symbol d-flex jtf-start pl-1" title={symbolInfo.code + " - " + (symbolInfo.symbolName ?? '') + " - " + symbolInfo.marketName} >
                    <input type="checkbox" onChange={(e) => changeFavSymbol(e.target.checked, symbolInfo.code)} checked={priceBoardFavSymbols.includes(symbolInfo.code)} />
                    <span style={{ cursor: 'pointer', marginLeft: '6px' }} id={symbolInfo.code + "_code"} className={symbolInfo.matchPriceOdd_color}>{symbolInfo.code}{(symbolInfo.referenceStatus && symbolInfo.referenceStatus !== '' && symbolInfo.referenceStatus !== '0' ? "*" : "")}</span>
                </div>
            )}
            <div className="prc-col2 text-right bg-smoke clr-ceil"><HighlightSpan id={symbolInfo.code + "_ceilPrice"} value={symbolInfo.ceilPrice} fireEvent={_fireEvent} /></div>
            <div className="prc-col2 text-right bg-smoke clr-floor"><HighlightSpan id={symbolInfo.code + "_floorPrice"} value={symbolInfo.floorPrice} fireEvent={_fireEvent} /></div>
            <div className="prc-col2 text-right bg-smoke clr-ref"><HighlightSpan id={symbolInfo.code + "_refPrice"} value={symbolInfo.refPrice} fireEvent={_fireEvent} /></div>

            <div className={clsx("prc-col2 text-right bdl-white", symbolInfo.bidPriceOdd3_color)}><HighlightSpan id={symbolInfo.code + "_bidPriceOdd3"} value={symbolInfo.bidPriceOdd3} fireEvent={_fireEvent} /></div>
            <div className={clsx("prc-col2 text-right mw-65", symbolInfo.bidPriceOdd3_color)}><HighlightSpan id={symbolInfo.code + "_bidQttyOdd3"} value={formatNumber(symbolInfo.bidQttyOdd3)} fireEvent={_fireEvent} /></div>
            <div className={clsx("prc-col2 text-right", symbolInfo.bidPriceOdd2_color)}><HighlightSpan id={symbolInfo.code + "_bidPriceOdd2"} value={symbolInfo.bidPriceOdd2} fireEvent={_fireEvent} /></div>
            <div className={clsx("prc-col2 text-right mw-65", symbolInfo.bidPriceOdd2_color)}><HighlightSpan id={symbolInfo.code + "_bidQttyOdd2"} value={formatNumber(symbolInfo.bidQttyOdd2)} fireEvent={_fireEvent} /></div>
            <div className={clsx("prc-col2 text-right", symbolInfo.bidPriceOdd1_color)}><HighlightSpan id={symbolInfo.code + "_bidPriceOdd1"} value={symbolInfo.bidPriceOdd1} fireEvent={_fireEvent} /></div>
            <div className={clsx("prc-col2 text-right mw-65", symbolInfo.bidPriceOdd1_color)}><HighlightSpan id={symbolInfo.code + "_bidQttyOdd1"} value={formatNumber(symbolInfo.bidQttyOdd1)} fireEvent={_fireEvent} /></div>

            <div className="prc-col4 text-center mw-75 mxw-75 has-symbol d-flex jtf-start bdl-white" title={symbolInfo.code + " - " + (symbolInfo.symbolName ?? '') + " - " + symbolInfo.marketName} >
                <span style={{ cursor: 'pointer', marginLeft: '6px' }} id={symbolInfo.code + "_code"} className={symbolInfo.matchPriceOdd_color}>{symbolInfo.code}{(symbolInfo.referenceStatus && symbolInfo.referenceStatus !== '' && symbolInfo.referenceStatus !== '0' ? "*" : "")}</span>
            </div>

            {priceBoardColumnConfig.showCodeMatch && (
                <div className="prc-col4 text-center mw-75 mxw-75 bg-smoke" title={symbolInfo.code + " - " + (symbolInfo.symbolName ?? '') + " - " + symbolInfo.marketName} >
                    <span style={{ cursor: 'pointer' }} id={symbolInfo.code + "_codeMatch"} className={symbolInfo.matchPriceOdd_color}>{symbolInfo.code}{(symbolInfo.referenceStatus && symbolInfo.referenceStatus !== '' && symbolInfo.referenceStatus !== '0' ? "*" : "")}</span>
                </div>
            )}
            <div className={clsx("prc-col2 text-right bg-smoke", symbolInfo.matchPriceOdd_color)}><HighlightSpan id={symbolInfo.code + "_matchPriceOdd"} value={symbolInfo.matchPriceOdd} fireEvent={_fireEvent} /></div>
            <div className={clsx("prc-col2 text-right bg-smoke", symbolInfo.matchPriceOdd_color)}><HighlightSpan id={symbolInfo.code + "_changePriceOdd"} value={symbolInfo.changePriceOdd} fireEvent={_fireEvent} /></div>
            <div className={clsx("prc-col2 text-right mw-55 bg-smoke", symbolInfo.matchPriceOdd_color)}><HighlightSpan id={symbolInfo.code + "_pctChangePriceOdd"} value={symbolInfo.pctChangePriceOdd + (symbolInfo.pctChangePriceOdd && symbolInfo.pctChangePriceOdd !== '' ? '%' : '')} fireEvent={_fireEvent} /></div>
            <div className={clsx("prc-col2 text-right mw-65 bg-smoke", symbolInfo.matchPriceOdd_color)}><HighlightSpan id={symbolInfo.code + "_matchQttyOdd"} value={formatNumber(symbolInfo.matchQttyOdd)} fireEvent={_fireEvent} /></div>

            {priceBoardColumnConfig.showTotalTradedQtty && (
                <>
                    {showTotalValue ? (
                        <div className={clsx("prc-col4 mw-85 text-right bg-smoke")}><HighlightSpan id={symbolInfo.code + "_totalTradedValueOdd"} value={formatNumberToM(symbolInfo.totalTradedValueOdd)} fireEvent={_fireEvent} /></div>
                    ) : (
                        <div className={clsx("prc-col4 mw-85 text-right bg-smoke")}><HighlightSpan id={symbolInfo.code + "_totalTradedQttyOdd"} value={formatNumber(symbolInfo.totalTradedQttyOdd)} fireEvent={_fireEvent} /></div>
                    )}
                </>
            )}

            <div className={clsx("prc-col2 text-right bdl-white", symbolInfo.offerPriceOdd1_color)}><HighlightSpan id={symbolInfo.code + "_offerPriceOdd1"} value={symbolInfo.offerPriceOdd1} fireEvent={_fireEvent} /></div>
            <div className={clsx("prc-col2 text-right mw-65", symbolInfo.offerPriceOdd1_color)}><HighlightSpan id={symbolInfo.code + "_offerQttyOdd1"} value={formatNumber(symbolInfo.offerQttyOdd1)} fireEvent={_fireEvent} /></div>
            <div className={clsx("prc-col2 text-right", symbolInfo.offerPriceOdd2_color)}><HighlightSpan id={symbolInfo.code + "_offerPriceOdd2"} value={symbolInfo.offerPriceOdd2} fireEvent={_fireEvent} /></div>
            <div className={clsx("prc-col2 text-right mw-65", symbolInfo.offerPriceOdd2_color)}><HighlightSpan id={symbolInfo.code + "_offerQttyOdd2"} value={formatNumber(symbolInfo.offerQttyOdd2)} fireEvent={_fireEvent} /></div>
            <div className={clsx("prc-col2 text-right", symbolInfo.offerPriceOdd3_color)}><HighlightSpan id={symbolInfo.code + "_offerPriceOdd3"} value={symbolInfo.offerPriceOdd3} fireEvent={_fireEvent} /></div>
            <div className={clsx("prc-col2 text-right mw-65", symbolInfo.offerPriceOdd3_color)}><HighlightSpan id={symbolInfo.code + "_offerQttyOdd3"} value={formatNumber(symbolInfo.offerQttyOdd3)} fireEvent={_fireEvent} /></div>

            <div className={clsx("prc-col2 text-right bg-smoke bdl-white", symbolInfo.highestPrice_color)}></div>
            <div className={clsx("prc-col2 text-right bg-smoke", symbolInfo.avgPrice_color)}></div>
            <div className={clsx("prc-col2 text-right bg-smoke", symbolInfo.lowestPrice_color)}></div>

            {priceBoardColumnConfig.showBuyForeignQtty && (
                <div className={clsx("prc-col2 text-right mw-70")}></div>
            )}
            {priceBoardColumnConfig.showSellForeignQtty && (
                <div className={clsx("prc-col2 text-right mw-70")}></div>
            )}
            {priceBoardColumnConfig.showRemainForeignQtty && (
                <div className={clsx("prc-col4 text-right mw-90")}></div>
            )}
        </div>
    )
});